import {z} from 'zod'

export const GRADIENT_PRESETS = {
  aurora: ['#4c1d95', '#6d28d9', '#1d4ed8', '#0ea5e9'] as const,
  sunset: ['#7c2d12', '#c2410c', '#db2777', '#9333ea'] as const,
  ocean: ['#0c4a6e', '#0369a1', '#0891b2', '#06b6d4'] as const,
  forest: ['#052e16', '#166534', '#15803d', '#059669'] as const,
  rose: ['#4a044e', '#86198f', '#be185d', '#e11d48'] as const,
  night: ['#020617', '#0f172a', '#1e1b4b', '#312e81'] as const,
}

export type GradientPreset = keyof typeof GRADIENT_PRESETS

export const settingsSchema = z.object({
  gradientPreset: z
    .enum(['aurora', 'sunset', 'ocean', 'forest', 'rose', 'night'])
    .default('aurora'),
  glassOpacity: z.number().min(0.05).max(0.4).default(0.15),
  instantFeedback: z.boolean().default(true),
  showProgressBar: z.boolean().default(true),
  showTimer: z.boolean().default(false),
  timerSeconds: z.number().min(5).max(120).default(30),
  enableHaptics: z.boolean().default(true),
  fontScale: z.number().min(0.8).max(1.4).default(1.0),
})

export type LiquidGlassSettings = z.infer<typeof settingsSchema>

export function getSettings(raw: Record<string, unknown>): LiquidGlassSettings {
  return settingsSchema.parse({
    gradientPreset: raw.gradientPreset ?? 'aurora',
    glassOpacity: raw.glassOpacity ?? 0.15,
    instantFeedback: raw.instantFeedback !== false,
    showProgressBar: raw.showProgressBar !== false,
    showTimer: raw.showTimer === true,
    timerSeconds: raw.timerSeconds ?? 30,
    enableHaptics: raw.enableHaptics !== false,
    fontScale: raw.fontScale ?? 1.0,
  })
}
